export const ADD_MILESTONE_BEGINS ='ADD_MILESTONE_BEGINS'
export const ADD_MILESTONE_SUCCESS ='ADD_MILESTONE_SUCCESS'
export const ADD_MILESTONE_FAILED ='ADD_MILESTONE_FAILED'

export const UPDATE_MILESTONE_BEGINS ='UPDATE_MILESTONE_BEGINS'
export const UPDATE_MILESTONE_SUCCESS ='UPDATE_MILESTONE_SUCCESS'
export const UPDATE_MILESTONE_FAILED ='UPDATE_MILESTONE_FAILED'

export const UPDATE_CALENDAR_DATE_SUCCESS =  'UPDATE_CALENDAR_DATE_SUCCESS'

export const CREATE_SLA_TEMPLATE_LOADER = 'CREATE_SLA_TEMPLATE_LOADER'

export const TEMPLATE_UPDATED_FOR_CLIENT = 'TEMPLATE_UPDATED_FOR_CLIENT'

export const UPDATE_CLIENT_USERS = 'UPDATE_CLIENT_USERS'